import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/img/logo.png";
import img1 from "../assets/img/wallet/hepton.png";
import img2 from "../assets/img/wallet/metamask.png";
import img3 from "../assets/img/wallet/trust.png";
import img4 from "../assets/img/wallet/walleto.png";
import { Bar, BrightnessIcon, Close, Wallet } from "../IconTheme";
import DropdownGroup from "./DropdownGroup";

const selectData = [
	{
		img: img1,
		name: "Hepton",
	},
	{
		img: img2,
		name: "MT",
	},
	{
		img: img3,
		name: "Trust",
	},
	{
		img: img4,
		name: "Walleto",
	},
];

const Header = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	return (
		<>
			<header>
				<div className="container">
					<div className="header-wrapper">
						<Link to="/" className="logo">
							<img src={logo} alt="" />
						</Link>
						<div
							className="bar ms-auto"
							onClick={() => setMenuOpen(!menuOpen)}
						>
							<Bar />
						</div>
						<div className={`menu-area  ${menuOpen ? "active" : ""}`}>
							<div
								className="close"
								onClick={() => setMenuOpen(!menuOpen)}
							>
								<Close />
							</div>
							<ul
								className="menu"
								onClick={() => setMenuOpen(!menuOpen)}
							>
								<li>
									<NavLink to="/">Home</NavLink>
								</li>
								<li>
									<NavLink to="/staking">Staking</NavLink>
								</li>
								<li>
									<NavLink to="/create-ido">Create IDO</NavLink>
								</li>
								<li>
									<NavLink to="/antex">Create Token</NavLink>
								</li>
								<li>
									<NavLink to="/docs">Docs</NavLink>
								</li>
							</ul>
							<div className="__gap-2 d-flex flex-wrap align-items-center">
								<Link to="#" className="brightness-icon">
									<BrightnessIcon />
								</Link>
								<DropdownGroup data={selectData} />
							</div>
							<div className="header-btns d-flex flex-wrap align-items-center">
								<Link to="#" className="cmn-btn">
									<Wallet /> <span>Connect Wallet</span>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
};

export default Header;
